import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
// import { Logout, publicAxios } from "./auth";
// import { useAtom } from "jotai";

// import { ApiEndPoint } from "./api-types";
// import { clinicAtom } from "./constant-atom";
// import { useCurrentRole } from "./Permission";
// import { Button } from "semantic-ui-react";

export default function ProtectedRoute(props) {
  // const navigate = useNavigate();

  // const [clinic] = useAtom(clinicAtom);

  // const { linked_clinics, role_name, user_personal_details_id } =
  //   useCurrentRole();

  const [islogedin, setIslogedin] = useState(true);

  let Cmp = props.Cmp;

  useEffect(() => {
    if (!localStorage.getItem("access_token")) {
      setIslogedin(false);
      // history.push('/login')
    }
  }, []);

  if (!islogedin) {
    return <Navigate to="/login"></Navigate>;
  } else {
    return (
      <div>
        <Cmp />
      </div>
    );
  }
  // else if(linked_clinics && clinic && role_name){

  //   if( linked_clinics.some(obj => obj.bhp_registered_clinic_id === clinic.id) || role_name ==="Patient"){

  //     return (
  //       <div>
  //         <Cmp />
  //       </div>
  //     );

  //   }
  //   else{

  //    return <div style={{width:"100%",height:"100vh",display:"flex",flexDirection:"column",textAlign:"center",justifyContent:"center",alignItems:"center", fontSize:"40px"}}>
  //       Your not linked with this clinic
  //       <Button color="instagram" size="medium" onClick={
  //         ()=>{
  //           Logout();
  //           navigate("/login");
  //         }
  //       }> Logout</Button>
  //       </div>
  //   }
  // }
}
